import React from 'react'
import HeroServiziPage from '../Components/Hero/HeroServiziPage';
import Servizi from '../Components/Servizi/ServiziPage';

const heroData = {
    bgImg: 'images/hero-bg.jpg',
    bgShape: 'shape/hero-shape.png',
    sliderImages: [
        {
            img: 'images/hero-img.png',
        },
        {
            img: 'images/hero-img1.png',
        },
        {
            img: 'images/hero-img2.png',
        },
        {
            img: 'images/hero-img.png',
        },
        {
            img: 'images/hero-img1.png',
        },
        {
            img: 'images/hero-img2.png',
        },
    ],
    title: "Trattamenti Ginecologia",
    description: "<h4>FemiLift: tecnologia laser avanzata per il benessere ginecologico e la salute intima.</h4>"
        + "Un approccio non invasivo per trattare secchezza, incontinenza, atrofia e infezioni intime. Il laser Pixel CO2 stimola collagene e tono muscolare, migliorando comfort e qualit&agrave; della vita in poche sedute."
};

const ServiziData = {
    img:"/images/pulmonary.png",
    content2: `
        <h4>Protocollo FemiLift</h4>
        <p>Il trattamento &egrave; non invasivo e consiste nell&apos;applicazione di 8 impulsi laser che trattano l&apos;intero canale vaginale. Questo approccio &egrave; mirato a risolvere i sintomi che influenzano la qualit&agrave; della vita e impediscono alle donne di vivere in modo sereno e attivo.</p>
        <ul>
          <li><strong>Durata del trattamento:</strong> circa 20 minuti</li>
          <li><strong>Numero di sedute consigliate:</strong> 3</li>
          <li><strong>Intervallo tra le sedute:</strong> 30-40 giorni</li>
        </ul>

        <h4>Vantaggi del Trattamento FemiLift</h4>
        <ul>
          <li>Soluzione sicura e non invasiva</li>
          <li>Miglioramento immediato della qualit&agrave; della vita</li>
          <li>Risultati duraturi</li>
        </ul>

        <p>FemiLift &egrave; la risposta ideale per le donne che cercano un trattamento efficace e delicato per migliorare il loro benessere intimo e ritrovare comfort e sicurezza.</p>

                    <br><br><br><br>
    `,
    content1: `
        <h2>FemiLift - soluzione avanzata per il Benessere Femminile</h2>
        <p>FemiLift &egrave; un trattamento ginecologico ambulatoriale innovativo e minimamente invasivo, progettato per risolvere le alterazioni del tono muscolare della parete vaginale e i fastidi associati, come l&apos;incontinenza urinaria, la secchezza vaginale e le infezioni intime ricorrenti.</p>

        <h3>Tecnologia Pixel CO2 per il Benessere Intimo</h3>
        <p>FemiLift sfrutta la <strong>tecnologia Pixel CO2</strong> che applica un effetto termico e microablativo per stimolare la neocollagenesi e migliorare il tono muscolare della parete vaginale. Il fascio laser viene suddiviso in 81 micro fasci, che penetrano la submucosa senza danneggiare i tessuti circostanti, favorendo la rigenerazione delle fibre di collagene ed elastina. Questa tecnologia &egrave; pi&ugrave; profonda ed efficace rispetto ad altre, garantendo risultati superiori.</p>

        <h4>Sintomi Trattati</h4>
        <ul>
          <li>Incontinenza urinaria</li>
          <li>Secchezza vaginale</li>
          <li>Infezioni intime ricorrenti</li>
          <li>Atrofia vaginale</li>
        </ul>
    `,
};

const AboutPage = () => {
  return (
    <>
      <HeroServiziPage data={heroData} />
      <Servizi data={ServiziData} />
    </>
  )
}

export default AboutPage
